import React, { useState } from "react";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";

const PostReviewModal = ({ isOpen, onClose, post, reviewPost }) => {
    const [remark, setRemark] = useState("");
    const [error, setError] = useState("");

    if (!isOpen || !post) return null;

    const handleReject = () => {
        if (!remark.trim()) {
            setError("Remark is required to reject a post");
            return;
        }
        setError("");
        reviewPost(post.id, 2, remark);
    };

    return (
        <ModalComponent show={isOpen} setShow={onClose} size="md" showClose={false}>
            <div className="w-[720px] max-w-[95vw] h-[85vh] rounded-2xl bg-white shadow-2xl flex flex-col overflow-hidden">

                {/* Header */}
                <div className="flex items-start justify-between px-6 py-4 border-b">
                    <div>
                        <h2 className="text-lg font-semibold text-gray-900">
                            {post.title || "Untitled Post"}
                        </h2>
                        <p className="text-sm text-gray-500">
                            Posted by{" "}
                            <span className="font-medium text-gray-700">{post.name}</span>
                            {post.mobile && ` • ${post.mobile}`}
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
                    >
                        ×
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">

                    {/* Media */}
                    {post.media?.length > 0 && (
                        <div className="relative w-full rounded-xl overflow-hidden border bg-gray-100">
                            <img
                                src={post.media[0]}
                                alt="media"
                                className="h-full w-full object-cover"
                            />
                        </div>
                    )}

                    {/* Content */}
                    <div className="rounded-xl border bg-gray-50 p-4">
                        <h4 className="text-sm font-semibold text-gray-700 mb-2">
                            Post Content
                        </h4>
                        <p className="text-sm text-gray-700 whitespace-pre-line">
                            {post.content_text || "-"}
                        </p>
                    </div>

                    {/* Reject Remark */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Reject Remark <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                            rows={3}
                            placeholder="Enter reason for rejection..."
                            className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                        />
                        {error && (
                            <p className="mt-1 text-xs text-red-600">{error}</p>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-3 px-6 py-4 border-t bg-white">
                    <button
                        onClick={handleReject}
                        className="rounded-lg bg-red-600 px-5 py-2 text-sm font-medium text-white hover:bg-red-700"
                    >
                        Reject
                    </button>
                    <button
                        onClick={() => { reviewPost(post.id, 1, "") }}
                        className="rounded-lg bg-green-600 px-5 py-2 text-sm font-medium text-white hover:bg-green-700"
                    >
                        Approve
                    </button>
                </div>

            </div>
        </ModalComponent>
    );
};

export default PostReviewModal;
